export default __webpack_public_path__ + "static/media/Melinda Liu.6cac77b9.png";